<div :class="$style.mT30">
  <div class="mt-serif  mt-serif--bold" :class="[$style.label, $style.lineHT35]">
    {{ $t('pages.promotions.new_promotion.form_details.promo_select_fonts.label') }}
  </div>

  <div class="row col is12">
    <div v-if="isSearch" class="mt-serif mt-serif--microMedium"
         :class="[$style.labelDesc, $style.mB10]">
      {{ $t('pages.promotions.new_promotion.form_details.promo_select_fonts.description') }}
    </div>
    <div :class="$style.selectFontWidth">
      <fou-select
        :class="[$style.inputFont, $style.inputCustomWidth]"
        :disabled="spinnerTaggedFamilies"
        :id="$vId(this, 'promo-fonts-select')"
        @option:selected="updateFontSelectValues"
        :options="fontSelect.options"
        :placeholder="$t('pages.promotions.new_promotion.form_details.promo_select_fonts.placeholder')"
        :model-value="fontSelect.values"
        :reduce="op => op"
        type="radio"
        name="fontSelect">
      </fou-select>
    </div>
    <div v-if="isSearch" :class="[$style.selectFontWidth, $style.mLN100]">
      <fou-select
        :class="[$style.inputFont, $style.inputCustomWidth]"
        close-on-select
        :disableOptionsList="setDisabledOptionsList"
        :disabled="spinnerTaggedFamilies"
        :id="$vId(this, 'promo-fonts-select')"
        @option:selected="val => loadingTaggedFamilies ? () => {} : setFontFamilyValues(val)"
        @option:deselected="onFontFamiliesDeselected"
        deselect-from-dropdown
        :options="fontFamilies.options"
        :placeholder="$t('pages.promotions.new_promotion.form_details.promo_select_fonts.placeholder')"
        :model-value="selectedList"
        :reduce="op => op"
        disable-auto-complete
        multiple
        name="fontFamilies"
        class-name="mt-checkbox"
        type="checkbox"
        tags-outside>
      </fou-select>
    </div>
    <div v-if="isSearch && !isList"
         class="mt-link"
         @click="viewAllFamilies"
         :class="[$style.mLN100, $style.lineHT35]">
      {{ $t('pages.promotions.new_promotion.form_details.promo_select_fonts.view_all') }}
    </div>
    <div v-if="isList"
         class="mt-link"
         @click="setListToFalse"
         :class="[$style.mLN100, $style.lineHT35]">
      {{ $t('pages.promotions.new_promotion.form_details.promo_select_fonts.hide_all') }}
    </div>
  </div>
  <!--===View-All List View===-->
  <div v-if="isList"
       class="mt-serif"
       :class="[$style.mT20, $style.checkedFontSection]">
    <span class="mt-serif">
      {{ $t('pages.promotions.new_promotion.form_details.promo_check_fonts.label') }}
    </span>
    <div :class="$style.allFamiliesWrapper">
      <ul :class="[$style.mT20, getColumnClass]">
        <li v-for="item, key in searchedFamilies" class="mt-list" :key="key">
          <div :class="[$style.childFlex1, $style.displayFlex]">
            <input
              :id="$vId(this, `families-${item.id}`)"
              v-model="viewAllTickedFamilesIdArr"
              :disabled="isDisableCheckbox(item)"
              type="checkbox"
              :value="item.id"
              name="Families"
              class="mt-checkbox"/>
            <label :for="$vId(this, `families-${item.id}`)">
              <span></span>
              <span class="mt-serif" :class="[$style.timePeriod1]">
                {{ item.familyName }}
              </span>
            </label>
          </div>
        </li>
      </ul>
    </div>
    <div class="row is12">
      <div class="is10">
      </div>
      <div class="is2">
        <button
          :disabled="addButtonToggle"
          @click="showCheckedFamilies($event, true)"
          class="mt-button"
          :class="$style.marginTop">
          {{ $t('pages.promotions.new_promotion.form_details.promo_check_fonts.add_button') }}
        </button>
      </div>
    </div>
  </div>
  <!--end-->
  <!--Tagged Families-->

  <template v-if="isChecked">
  <div :class="$style.selectFontStyleWrapper" v-for="data in taggedFamilies" :key="data.familyName">
    <div :class="(data.skus.length === 1) ? $style.fontsHeadingWrapperForOnlyStyle : $style.fontsHeadingWrapper">
      <h1 class="mt-serif mt-serif--bold mt-h3 mt-serif--nowrap mt-display-extrabold">{{ data.familyName }}</h1>
      <template v-if="data.skus.length === 1">
        <div :class="$style.packWrapper" v-for="skusData in data.skus">
            <!--single style pack-->
            <input
              :id="$vId(this, `${skusData.skuId}`)"
              type="checkbox"
              v-model="onlySingleStylePack"
              @change="setSingleStylePack(data)"
              :value="skusData.skuId"
              name="single style"
              class="mt-checkbox"/>
            <label :for="$vId(this, `${skusData.skuId}`)">
              <span></span>
              <span class="mt-serif" :class="[$style.timePeriod1]">
                {{ skusData.description }}
              </span>
            </label>
        </div>
      </template>

      <!--end-->
      <button
        v-if="isScheduledPromotion ? () => { return true } : isOldTaggedFamilyInEditPromotion(data.id)"
        type="button"
        class="out-right"
        :class="$style.noMargin"
        :id="$vId(this, 'delete')"
        @click="removeFamily(data.id)">
        <trash-icon></trash-icon>
      </button>
    </div>
    <div
      :class="isFamilyCustomPackAvailable(data.skus) ? $style.fontsDetailsWrapper : $style.fontsDetailsWrapperForOnlyOneChild"
      v-if="data.skus.length > 1"><!--Font Details Packs-->
      <div :class="$style.allPacksWrapper"><!--All Packs Column-->
        <div :class="$style.packWrapper" v-if="isFamilyCustomPackAvailable(data.skus)"><!--All Family Pack-->
          <input
            :id="$vId(this, `allPacks-${data.id}`)"
            type="checkbox"
            v-model="allPacks"
            @change="setSelectedStyles(data, 'allPacks')"
            :value="`allPacks-${data.id}`"
            name="All Packs"
            class="mt-checkbox"/>
          <label :for="$vId(this, `allPacks-${data.id}`)">
            <span></span>
            <span class="mt-serif mt-serif--bold" :class="[$style.timePeriod1]">All Packs</span>
          </label>
        </div><!--end-->
        <div :class="$style.packWrapper" v-for="skusData in data.skus"><!--Family Pack-->
          <template v-if="skusData.packageType === 'familyPackage'">
            <input
              :id="$vId(this, `${skusData.skuId}`)"
              type="checkbox"
              v-model="familyCustomPacks"
              @change="setSelectedStyles(data, 'familyPack')"
              :value="skusData.skuId"
              name="Family Pack"
              class="mt-checkbox"/>
            <label :for="$vId(this, `${skusData.skuId}`)">
              <span></span>
              <span class="mt-serif" :class="[$style.timePeriod1]">
              {{ skusData.description }}
            </span>
            </label>
          </template>
        </div><!--end-->
        <div :class="$style.packWrapper" v-for="skusData in data.skus"><!--Custom Pack-->
          <template v-if="skusData.packageType === 'customPackage'">
            <input
              :id="$vId(this, `${skusData.skuId}`)"
              type="checkbox"
              v-model="familyCustomPacks"
              @change="setSelectedStyles(data, 'customPack')"
              :value="skusData.skuId"
              name="Custom Pack"
              class="mt-checkbox"/>
            <label :for="$vId(this, `${skusData.skuId}`)">
              <span></span>
              <span class="mt-serif" :class="[$style.timePeriod1]">
              {{ skusData.description }}
            </span>
            </label>
          </template>
        </div><!--end-->
      </div><!--end-->
      <div :class="$style.allStylesWrapper"><!--All Styles Column-->
        <div :class="$style.packWrapper" v-if="isSingleStylePackAvailable(data.skus)"><!--All Styles Pack-->
          <input
            :id="$vId(this, `allStyles-${data.id}`)"
            type="checkbox"
            v-model="allStyles"
            @change="setSelectedStyles(data, 'allStyles')"
            :value="`allStyles-${data.id}`"
            name="All Styles"
            class="mt-checkbox"/>
          <label :for="$vId(this, `allStyles-${data.id}`)">
            <span></span>
            <span class="mt-serif mt-serif--bold" :class="[$style.timePeriod1]">All Styles</span>
          </label>
        </div><!--end-->
        <div :class="$style.packWrapper" v-for="skusData in data.skus">
          <template v-if="skusData.packageType === 'singleStyle'">
            <!--single style pack-->
            <input
              :id="$vId(this, `${skusData.skuId}`)"
              type="checkbox"
              v-model="stylePacks"
              @change="setSelectedStyles(data, 'singleStyle')"
              :value="skusData.skuId"
              name="single style"
              class="mt-checkbox"/>
            <label :for="$vId(this, `${skusData.skuId}`)">
              <span></span>
              <span class="mt-serif" :class="[$style.timePeriod1]">
              {{ skusData.description }}
            </span>
            </label>
          </template>
        </div><!--end-->
      </div><!--end-->
    </div><!--end-->
  </div>
  <p v-if="skuLimitReached && secretCodePresent" class="mt-error">{{$t('pages.promotions.new_promotion.sku_limit')}}</p>
  </template>
  <!--end-->
  <!--Error Tagged Families-->
  <template v-if="isChecked && taggedErrorFamilies.length > 0">
    <div v-for="data in taggedErrorFamilies"
        :key="data.errorInfo.familyId">
      <div :class="$style.errorTaggedFamiliesWrapper">
        <div :class="$style.fontsHeadingWrapper">
          <h1 class="mt-serif mt-serif--bold mt-h3 mt-serif--nowrap">{{ data.errorInfo.familyName }}</h1>
          <div @click="removeErrorFamily(data.errorInfo.familyId)">
            <cancel-icon :dynamicWidth="15" dynamicHeight="15" :className="$style.cancelIcon"></cancel-icon>
          </div>
        </div>
        <p class="mt-serif mt-h6">There is an issue with this family which prevents it from being part of a promotion.
          Please contact the foundry team at foundrysupport@monotype.com for assistance. </p>
      </div>
    </div>
  </template>
  <!--end-->
  <div :class="$style.taggedFamilyMargin" v-if="spinnerTaggedFamilies">
    <animation-processing fill="new-blue" :class="$style.taggedFamilySpinner"></animation-processing>
    <span class="mt-sans mt-sans--size1">
      {{ $t('pages.promotions.new_promotion.form_details.promo_check_fonts.spinner_tagged_families') }}
    </span>
  </div>
</div>
